module.exports = __webpack_public_path__ + "static/media/Subscribe01-640-480.a1d73c3e.jpg";